module.exports = __webpack_public_path__ + "static/media/crystalfiber.3d6f371f.svg";